import Notifications from '@mui/icons-material/Notifications';
import { Stack, Typography } from '@mui/material';
import { useFieldHelper } from 'framework/ui/field';
import { Tooltip } from 'framework/ui/mui-builder';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import { Box } from '@mui/material';
import { RetentionRiskFollowUp } from './types';

interface FollowUpFieldProps {
  source?: string;
}

const FollowUpField = ({ source = 'retentionRiskFollowUps' }: FollowUpFieldProps) => {
  const { getValue } = useFieldHelper<RetentionRiskFollowUp[]>({ source });

  const followUps = getValue();
  const { formatDate } = useDateService();

  const tooltipContent = followUps?.length ? (
    <Box>
      {followUps?.map(followUp => (
        <Box mb={2} key={followUp.id}>
          <b>{formatDate(followUp.followUpDate, DATE_FORMAT.NATURAL_SHORT)} - </b>
          {followUp.description}
        </Box>
      ))}
    </Box>
  ) : null;

  return followUps?.length ? (
    <Tooltip title={tooltipContent} placement="top">
      <Stack direction="row" alignItems="center" flexShrink={0}>
        <Notifications color="primary" sx={{ fontSize: 14, mr: 0.625 }} />

        <Typography variant="body2" color="primary">
          {formatDate(followUps?.[0]?.followUpDate, DATE_FORMAT.NATURAL_SHORT)}
        </Typography>
      </Stack>
    </Tooltip>
  ) : null;
};

export default FollowUpField;
